<video #videoElement autoplay loop poster="./../../../../assets/images.background/blue_art.jpg" id="videoElementID">
  <source src="./../../../../assets/video.site//Assenheimers.2015.No.Sound.webm" type="video/webm" />
  <source src="./../../../../assets/video.site//Assenheimers.2015.No.Sound.mp4" type="video/mp4" />  
</video>
<div id="textDiv" #textDiv>
  <h1>Welcome</h1>
  <p>{{_PlayingStatus}}</p>  
  <button (click)="PauseToggle($event);" #PauseButton>Pause</button>
</div>
